import React from 'react'
import { responsiveScreens } from 'fuse_common/constants/responsive-screens'

export type Breakpoint = keyof typeof responsiveScreens

export const breakpoints = Object.entries(responsiveScreens)
  .sort((a, b) => {
    return Number(a[0]) - Number(b[0])
  })
  .map(([name, size]) => ({
    name,
    query: `not all and (min-width: ${size})`,
  }))

export type UseBreakpointsValue = {
  breakpoint: Breakpoint | null
  isMobile: boolean
  defined: boolean
}

export const useBreakpoints = (): UseBreakpointsValue => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint | null>(null)

  React.useEffect(() => {
    const mediaQueryList = breakpoints.map(({ query }) => window.matchMedia(query))
    const updateBreakpoint = () => {
      const newBreakpoint = breakpoints.find(({ query }) => window.matchMedia(query).matches)?.name as Breakpoint | null
      setBreakpoint(newBreakpoint ?? null)
    }
    updateBreakpoint()
    // Using deprecated addListener to Support Safari 13
    mediaQueryList.forEach((query) => query.addListener(updateBreakpoint))
    return () => {
      mediaQueryList.forEach((query) => query.removeListener(updateBreakpoint))
    }
  }, [])

  return { breakpoint, isMobile: ['sm', 'md'].includes(breakpoint ?? ''), defined: breakpoint !== null }
}
